import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-[hsl(var(--md-chalk))]">
      <Navbar />
      <main className="flex-1 pt-[72px] md:pt-[88px]" data-testid="page-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
